// extracted by mini-css-extract-plugin
module.exports = {"container":"_1w-WRHZCYO2yzd4j4948G-"};